<!--
  创建时间：2024/8/19 15:17
  创建人：toyehuang
  文件描述：Home
-->
<template>
  <div class="home-box bgff">
    <banner-swiper />
    <div class="def-w">
      <data-stats />
      <div class="f-b-c mb-30 mt-30">
        <tab-news />
        <login-entry />
      </div>
      <!--      <login-entry class="mt-10" />-->
      <advert-comp adv-type="AD_A" />
      <purchase-block project-type="GC" des-txt="" />
      <purchase-block project-type="FW" des-txt="" />
      <advert-comp adv-type="AD_B" class="mt-30" />
      <purchase-block project-type="HW" des-txt="" />
      <purchase-block project-type="QT" des-txt="" />
      <friendly-link />
    </div>
  </div>
</template>

<script>
import BannerSwiper from "@/views/home/components/BannerSwiper.vue";
import LoginEntry from "@/views/home/components/LoginEntry.vue";
import TabNews from "@/views/home/components/TabNews.vue";
import AdvertComp from "@/views/home/components/AdvertComp.vue";
import PurchaseBlock from "@/views/home/components/PurchaseBlock.vue";
import FriendlyLink from "@/views/home/components/FriendlyLink.vue";

export default {
  name: "Home",
  components: { FriendlyLink, PurchaseBlock, AdvertComp, TabNews, LoginEntry, BannerSwiper },
  props: {
  },
  data() {
    return {};
  },
  // 监听属性 类似于data概念
  computed: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {}
};
</script>

<style scoped lang="scss">
.home-box{padding-bottom: 50px;}
</style>
